import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'removeHTML' })
export class RemoveHtmlPipe implements PipeTransform {

    constructor() { }

    transform(html: string) {
      //  return this.htmlDecode(html.replace(/<[^>]*>/g, '').replace('&nbsp;', ' ').replace('&ndash;','–'));
      return this.htmlDecode(html);
    }

    private htmlDecode(input: string) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
      }
}